import moment from 'moment';
import {
  CHANNEL_LABEL,
  LANGUAGE_LABEL,
  STATUS_META,
  TERMINAL_STATUSES,
} from './constants';

export const UNTITLED = 'Untitled content';

export const formatDateTime = value =>
  value ? moment(value).format('DD MMM YYYY, hh:mm A') : '—';

export const languageLabel = value => LANGUAGE_LABEL[value] || value || '—';

export const channelLabel = value => CHANNEL_LABEL[value] || value;

export const statusMeta = value =>
  STATUS_META[value] || {label: value || 'Unknown', color: 'default'};

export const isTerminal = status => TERMINAL_STATUSES.includes(status);

export const truncate = (value, max = 80) => {
  const text = String(value ?? '');
  return text.length > max ? `${text.slice(0, max)}…` : text;
};

/** "English", "English and French", "English, French and Spanish". */
export const joinWithAnd = items => {
  const list = items.filter(Boolean);
  if (list.length <= 1) return list[0] || '';
  return `${list.slice(0, -1).join(', ')} and ${list[list.length - 1]}`;
};

export const pluralise = (count, singular, plural) =>
  `${count} ${count === 1 ? singular : plural || `${singular}s`}`;

/** Optional text fields: blank / whitespace-only is sent as null, not "". */
export const nullIfBlank = value => {
  const trimmed = (value ?? '').trim();
  return trimmed.length ? trimmed : null;
};

export const isHttpUrl = value => {
  try {
    const {protocol} = new URL(value);
    return protocol === 'http:' || protocol === 'https:';
  } catch (e) {
    return false;
  }
};

/**
 * These resolvers raise normal GraphQL errors, so the code lives on
 * `extensions.code` of the first error rather than in a response union.
 */
export const errorCodeOf = error =>
  error?.graphQLErrors?.[0]?.extensions?.code ||
  error?.graphQLErrors?.[0]?.errorTypeEnum ||
  null;

export const errorMessageOf = error =>
  error?.graphQLErrors?.[0]?.message || error?.message || null;
